// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"text-content-module--wrapper--nY_an","container":"text-content-module--container--33HmF"};